"use strict";

exports.__esModule = true;
exports.default = void 0;
var _error = require("@apollo/client/link/error");
var _authActions = require("../auth/authActions");
var _client = require("@apollo/client");
var _authSelectors = require("../auth/authSelectors");
var createRefreshLink = function createRefreshLink(store) {
  var isRefreshing = false;
  var pendingRequests = [];
  var resolvePendingRequests = function resolvePendingRequests() {
    pendingRequests.map(function (callback) {
      return callback();
    });
    pendingRequests = [];
  };
  var getNewToken = function getNewToken() {
    var session = (0, _authSelectors.sessionSelector)(store.getState());
    if (!session || !session.refreshToken || !session.provider) {
      return Promise.reject();
    }
    var body = {
      refreshToken: session.refreshToken,
      provider: session.provider
    };
    var url = "/login/refresh";
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.json();
    });
  };
  return (0, _error.onError)(function (errors) {
    var graphQLErrors = errors.graphQLErrors,
      operation = errors.operation,
      forward = errors.forward;
    if (graphQLErrors) {
      graphQLErrors.forEach(function (err) {
        var forward$;
        if (!err.extensions || err.extensions.code !== 'AUTH_NOT_AUTHENTICATED') {
          return;
        }
        if (!isRefreshing) {
          isRefreshing = true;
          forward$ = (0, _client.fromPromise)(getNewToken().then(function (json) {
            var payload = {
              accessToken: json.access_token,
              refreshToken: json.refresh_token,
              idToken: json.id_token,
              expiresIn: json.expires_in
            };
            store.dispatch((0, _authActions.authRefreshSuccess)(payload));
            resolvePendingRequests();
            return json.access_token;
          }).catch(function () {
            store.dispatch((0, _authActions.authRequestError)({}));
          }).finally(function () {
            isRefreshing = false;
          })).filter(function (value) {
            return Boolean(value);
          });
        } else {
          // Will only emit once the Promise is resolved
          forward$ = (0, _client.fromPromise)(new Promise(function (resolve) {
            pendingRequests.push(function () {
              return resolve();
            });
          }));
        }
        return forward$.flatMap(function () {
          return forward(operation);
        });
      });
    }
  });
};
var _default = exports.default = createRefreshLink;